import cx from 'classnames';

import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

const SlideTitle = ({ slide, index }) => {
  if (!slide.title) return null;

  const TitleTag = slide.title_as_h1 ? 'h1' : 'div';

  return (
    <TitleTag
      className={cx('title', { bold: slide.bold_title })}
      id={`title-${index}`}
    >
      {slide.href?.[0] && !slide.href_title ? (
        <UniversalLink item={slide.href[0]}>{slide.title}</UniversalLink>
      ) : (
        slide.title
      )}
    </TitleTag>
  );
};

export default SlideTitle;
